import Vue from 'vue'
import VueRouter from 'vue-router'
import userUtils from "@/utils/userUtils";
import store from '@/store';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const HelperRepository = RepositoryFactory.get("helper");

Vue.use(VueRouter);

const routes = [
  {
    path: '/addmarkingstructure',
    name: 'AddMarkingStructure',
    component: () => import('@/views/AddMarkingStructure'),
    meta: {
      requiresAuth: true
    }     
  },
  {
    path: '/AuditTrailMarkingStructure',
    name: 'MarkingStructure',
    component: () => import('@/views/AuditTrail/MarkingStructure'),
    meta: {
      requiresAuth: true
    }     
  },
  {
    path: '/AuditTrailIntegrationLogs',
    name: 'IntegrationLogs',
    component: () => import('@/views/AuditTrail/IntegrationLogs'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/AuditTrailPaymentLogs',
    name: 'PaymentLogs',
    component: () => import('@/views/AuditTrail/PaymentLogs'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/AuditTrailMarkCapture',
    name: 'MarkCapture',
    component: () => import('@/views/AuditTrail/MarkCapture'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/AuditTrailPaperLogs',
    name: 'PaperLogs',
    component: () => import('@/views/AuditTrail/PaperLogs'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/bulkallocatemarkers',
    name: 'BulkAllocateMarkers',
    component: () => import('@/views/BulkAllocateMarkers'),
    meta: {
      requiresAuth: true
    }     
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard'),
    meta: {
      requiresAuth: true
    }     
  },   
  {
    path: '/downloadfile/:horaceguid',
    name: 'DownloadFile',
    component: () => import('@/views/DownloadFile'),
    meta: {
      requiresAuth: true
    }     
  },   
  {
    path: '/editassessment/:id',
    name: 'EditAssessment',
    component: () => import('@/views/EditAssessment'),
    meta: {
      requiresAuth: true
    }     
  },     
  {
    path: '/editmarkingstructure/:id',
    name: 'EditMarkingStructure',
    component: () => import('@/views/EditMarkingStructure'),
    meta: {
      requiresAuth: true
    }     
  },   
  {
    path: '/edituser/:userid',
    name: 'EditUser',
    component: () => import('@/views/EditUser'),
    meta: {
      requiresAuth: true
    } 
  },     
  {
    path: '/externallogin/:token',
    name: 'ExternalLogin',
    component: () => import('@/views/ExternalLogin'),
    meta: {
      requiresAuth: false
    }     
  },  
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: () => import('@/views/Password/ForgotPassword.vue'),
    meta: {
      requiresAuth: false,
      anonymous: true
    }
  },  
  {
    path: '/recoverPassword',
    name: 'recoverPassword',
    component: () => import('@/views/Password/RecoverPassword.vue'),
    meta: {
      requiresAuth: false,
      anonymous: true
    }
  },  
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login'),
    meta: {
    }    
  },
  {
    path: '/manualmarkingmanagement',
    name: 'ManualMarkingManagement',
    component: () => import('@/views/ManualMarkingManagement'),
    meta: {
      requiresAuth: true
    }     
  },      
  {
    path: '/manualsubmissions',
    name: 'ManualSubmissions',
    component: () => import('@/views/ManualSubmissions'),
    meta: {
      requiresAuth: true
    }     
  }, 
  {
    path: '/markapaper',
    name: 'MarkAPaper',
    component: () => import('@/views/MarkAPaper'),
    meta: {
      requiresAuth: true
    }     
  },    
  {
    path: '/markerpayment',
    name: 'MarkerPayment',
    component: () => import('@/views/MarkerPayment'),
    meta: {
      requiresAuth: true
    }     
  },    
  {
    path: '/markerpaymentsummary',
    name: 'MarkerPaymentSummary',
    component: () => import('@/views/MarkerPaymentSummary'),
    meta: {
      requiresAuth: true
    }     
  },
  {
    path: '/markingmanagement',
    name: 'MarkingManagement',
    component: () => import('@/views/MarkingManagement'),
    meta: {
      requiresAuth: true
    }     
  },           
  {
    path: '/markingpricestructure',
    name: 'MarkingPriceStructure',
    component: () => import('@/views/MarkingPriceStructure'),
    meta: {
      requiresAuth: true
    }     
  },    
  {
    path: '/markingtool/:token/:paperid',
    name: 'MarkingTool',
    component: () => import('@/views/MarkingTool'),
    meta: {
      requiresAuth: false
    }     
  },   
  {
    path: '/markingstructuremanager',
    name: 'MarkingStructureManager',
    component: () => import('@/views/MarkingStructureManager'),
    meta: {
      requiresAuth: true
    } 
  },  
  {
    path: '/newuser',
    name: 'NewUser',
    component: () => import('@/views/NewUser'),
    meta: {
      requiresAuth: true
    } 
  },   
  {
    path: '/onlinemarkingmanagement',
    name: 'OnlineMarkingManagement',
    component: () => import('@/views/OnlineMarkingManagement'),
    meta: {
      requiresAuth: true
    }     
  },    
  {
    path: '/onlinepapers',
    name: 'OnlinePapers',
    component: () => import('@/views/OnlinePapers'),
    meta: {
      requiresAuth: true
    }     
  },   
  {
    path: '/questionlevelreport',
    name: 'QuestionLevelReport',
    component: () => import('@/views/QuestionLevelReport'),
    meta: {
      requiresAuth: true
    }     
  },       
  {
    path: '/usermanagement',
    name: 'UserManagement',
    component: () => import('@/views/UserManagement'),
    meta: {
      requiresAuth: true
    }     
  },  
  {
    path: '/viewassessment/:id',
    name: 'ViewAssessment',
    component: () => import('@/views/ViewAssessment'),
    meta: {
      requiresAuth: true
    }     
  },    
  {
    path: '/viewmarkingstructure/:id',
    name: 'ViewMarkingStructure',
    component: () => import('@/views/ViewMarkingStructure'),
    meta: {
      requiresAuth: true
    }     
  },    
  {
    path: '/viewuser/:userid',
    name: 'ViewUser',
    component: () => import('@/views/ViewUser'),
    meta: {
      requiresAuth: true
    } 
  },      
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import('@/views/Maintenance')
  },  
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {

  // check maintenance mode

  let { data } = await HelperRepository.getMaintenanceMode();
  let maintenanceMode = data.data

  store.commit("setMaintenanceMode", maintenanceMode);   

  if (!maintenanceMode) {
    store.commit("setMaintenanceUser", false);   
    //alert(JSON.stringify(store.state.maintenanceUser))
  }

  if (to.name != 'maintenance') {
    if (maintenanceMode && !store.state.maintenanceUser) {
      next({
        path: '/maintenance'
      });
    }
  } else {
    if (!maintenanceMode) {
      next({
        path: '/'
      });
    }
  } 

  // clear or set usage of cached marking structure search
  if ( (from.path.substring(0, 22) == '/editmarkingstructure/') || 
      (from.path.substring(0, 16) == '/editassessment/') ||
      (from.path.substring(0, 20) == '/addmarkingstructure')  ) {
    store.commit("setAutoSearch", true);
  } else {
    store.commit("setAutoSearch", false);
  }

  // does route exist?
  if (router.resolve(to.path).resolved.matched.length <= 0) {
    
    // no, route not found, so redirect to either login view 
    // or dashboard depending on signed in status

    if (userUtils.isSignedIn()) {
      
      next({
        path: userUtils.defaultRoute()
      })

    } else {
      next({
        path: '/login'
      })      
    }

  } else {

    // does route require user to be signed in?
    if (to.matched.some(record => record.meta.requiresAuth)) {
      
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!userUtils.isSignedIn()) {
        next({
          path: '/login'
        })
      } else {
          next() // make sure to always call next()!
      }

    } else {

      // is the user signed in and trying to access the login page
      if (userUtils.isSignedIn() && (to.path == '/login')) {
        // yes, so redirect them to their dashboard
        next({
          path: userUtils.defaultRoute()
        })
      } else {
        next() // make sure to always call next()!
      }
      
    }
  }

})

export default router